import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { ClockIcon } from 'lucide-react';
import { Button } from './ui/Button';
export function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });
  useEffect(() => {
    // Set target date to 2 days, 5 hours, 30 minutes from now
    const targetDate = new Date();
    targetDate.setDate(targetDate.getDate() + 2);
    targetDate.setHours(targetDate.getHours() + 5);
    targetDate.setMinutes(targetDate.getMinutes() + 30);
    const interval = setInterval(() => {
      const now = new Date().getTime();
      const distance = targetDate.getTime() - now;
      if (distance < 0) {
        clearInterval(interval);
        return;
      }
      setTimeLeft({
        days: Math.floor(distance / (1000 * 60 * 60 * 24)),
        hours: Math.floor(distance % (1000 * 60 * 60 * 24) / (1000 * 60 * 60)),
        minutes: Math.floor(distance % (1000 * 60 * 60) / (1000 * 60)),
        seconds: Math.floor(distance % (1000 * 60) / 1000)
      });
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const timeBlocks = [{
    label: 'DÍAS',
    value: timeLeft.days
  }, {
    label: 'HORAS',
    value: timeLeft.hours
  }, {
    label: 'MINUTOS',
    value: timeLeft.minutes
  }, {
    label: 'SEGUNDOS',
    value: timeLeft.seconds
  }];
  return <section className="py-16 bg-gradient-to-b from-[#1A0230] to-[#0D0118] relative px-4 sm:px-6 lg:px-8 border-y border-[#FF2D8A]/20" data-id="element-47">
      <div className="max-w-4xl mx-auto text-center" data-id="element-48">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="inline-flex items-center justify-center p-4 rounded-3xl bg-gradient-to-r from-[#FF2D8A]/10 to-[#9D00FF]/10 border border-[#FF2D8A]/30 backdrop-blur-md w-full" data-id="element-49">
          <div className="flex flex-col items-center w-full" data-id="element-50">
            <div className="flex items-center gap-3 mb-4" data-id="element-51">
              <ClockIcon className="w-8 h-8 text-[#FFD700] animate-pulse" data-id="element-52" />
              <h2 className="text-2xl sm:text-3xl font-bold text-white uppercase tracking-wide" data-id="element-53">
                ¡ESTA OFERTA SE TERMINA PRONTO!
              </h2>
            </div>

            <p className="text-gray-300 mb-8 max-w-2xl" data-id="element-54">
              El precio de{' '}
              <span className="text-[#FF2D8A] font-bold text-xl" data-id="element-55">
                $14.999 ARS
              </span>{' '}
              es por TIEMPO LIMITADO. Después vuelve al precio original.
            </p>

            <div className="flex flex-wrap justify-center gap-4 sm:gap-6 mb-8" data-id="element-56">
              {timeBlocks.map((block, index) => <div key={index} className="flex flex-col items-center" data-id="element-57">
                  <div className="w-20 h-24 sm:w-24 sm:h-28 bg-[#0D0118] border border-[#FF2D8A]/40 rounded-xl flex items-center justify-center shadow-[0_0_15px_rgba(255,45,138,0.2)]" data-id="element-58">
                    <span className="text-4xl sm:text-5xl font-black text-transparent bg-clip-text bg-gradient-to-b from-white to-gray-400" data-id="element-59">
                      {block.value.toString().padStart(2, '0')}
                    </span>
                  </div>
                  <span className="mt-2 text-xs sm:text-sm font-bold text-[#FFD700] tracking-widest" data-id="element-60">
                    {block.label}
                  </span>
                </div>)}
            </div>

            <Button href="#pricing" className="w-full sm:w-auto" data-id="element-61">
              ASEGURAR MI LUGAR AHORA
            </Button>
          </div>
        </motion.div>
      </div>
    </section>;
}